<template lang="pug">
.file-article-creation-form
  v-form(ref="form")
    v-container
      v-layout(wrap)
        v-flex(xs12)
          v-text-field(
            v-model="title"
            :counter="20"
            :error-messages="titleErrors"
            label="標題"
            outline
            @input="$v.title.$touch()"
            @blur="$v.title.$touch()")
        v-flex(xs12)
          v-text-field(
            v-model="fileName"
            label="上傳文件"
            prepend-icon='attach_file'
            readonly
            outline
            :error-messages="fileErrors"
            @input="$v.file.$touch()"
            @blur="$v.file.$touch()"
            @click="pickFile")
          input(
            ref="file"
            v-show="false"
            type="file"
            @change="onFilePicked")
      form-actions(
        :loading="formMixin_loading"
        @cancel="$emit('cancel')"
        @submit="submit") {{ formMixin_message }}
</template>
<script>
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import get from "lodash/get";
import { storage } from "@/firebase";
import { formMixin } from "@/mixins";

export default {
  name: "FileArticleCreationForm",
  mixins: [formMixin, validationMixin],
  validations: {
    title: { required, maxLength: maxLength(20) },
    file: { required }
  },
  data() {
    return {
      title: null,
      content: null,
      file: null,
      fileURL: null
    };
  },
  computed: {
    fileName() {
      return get(this.file, "name", null);
    },
    titleErrors() {
      const errors = [];
      if (!this.$v.title.$dirty) return errors;
      !this.$v.title.maxLength && errors.push("最多20個字");
      !this.$v.title.required && errors.push("請填寫標題");
      return errors;
    },
    fileErrors() {
      const errors = [];
      if (!this.$v.file.$dirty) return errors;
      !this.$v.file.required && errors.push("請上傳文件");
      return errors;
    }
  },
  methods: {
    pickFile() {
      this.$refs.file.click();
    },
    onFilePicked(e) {
      const file = e.target.files[0];
      this.file = file;
    },
    submit() {
      const ref = storage.ref();
      const path = `admin/documents/${this.fileName}`;
      const fileRef = ref.child(path);

      return new Promise(res => {
        const task = fileRef.put(this.file);
        task.then(async () => {
          const URL = await task.snapshot.ref.getDownloadURL();
          this.fileURL = URL;
          const response = await this.formMixin_submit(
            ["title", "fileURL"],
            "post",
            "file"
          );

          this.formMixin_reset();

          res(response);
        });
      });
    }
  }
};
</script>
